import Icon from 'components/icons/Icon';
import React from 'react';

const ChevronUpDownIcon: React.FC<{
  sectionId: string;
  activeSectionId: string | null;
}> = ({ sectionId, activeSectionId }) => (
  <Icon
    name={activeSectionId === sectionId ? 'Chevron_Up' : 'Chevron_Down'}
    testID="dropdown-chevron"
    size="s"
  />
);

export default ChevronUpDownIcon;
